module.exports = __webpack_public_path__ + "img/partner1.fec42f8e.png";